import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";


const __default__ = {
  name: "StreetView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  latitude: {
    type: Number,
    default: 37.4044893,
  },
  longitude: {
    type: Number,
    default: 127.0982259,
  },
  pan: {
    type: Number,
    default: 0,
  },
  tilt: {
    type: Number,
    default: 15,
  },
  fov: {
    type: Number,
    default: 100,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const streetViewContainer = ref<HTMLElement>();
const pano = ref();
const marker = ref();
const addScript = () => {
  const naverMapScript = document.createElement("script");
  naverMapScript.setAttribute(
    "src",
    `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${process.env.VUE_APP_NAVER_CLIENT_ID}&submodules=panorama,drawing`
  );
  naverMapScript.async = true;
  document.head.appendChild(naverMapScript);
  naverMapScript.onload = () => {
    // 로드뷰 callback함수
    window.naver.maps.onJSContentLoaded = () => {
      initMap();
    };
  };
};

const initMap = () => {
  setTimeout(() => {
    pano.value = new window.naver.maps.Panorama("pano", {
      position: new window.naver.maps.LatLng(props.latitude, props.longitude),
      pov: {
        pan: props.pan,
        tilt: props.tilt,
        fov: props.fov,
      },
    });
    addMaker();
    window.naver.maps.Event.addListener(pano.value, "init", () => {
      pano.value.setZoom(0);
      setPanoViewPort();
    });
  }, 300);
};

const addMaker = () => {
  marker.value = new window.naver.maps.Marker({
    position: new window.naver.maps.LatLng(props.latitude, props.longitude),
  });
  marker.value.setMap(pano.value);
};

const setPanoViewPort = () => {
  const projection = pano.value.getProjection();
  const viewpoint = projection.fromCoordToPov(marker.value.getPosition());
  pano.value.setPov(viewpoint);
};

onMounted(() => {
  window.naver ? initMap() : addScript();
});

const __returned__ = { props, streetViewContainer, pano, marker, addScript, initMap, addMaker, setPanoViewPort }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})